import {isValid, parse, set} from 'date-fns'

export function userFriendlyParseDate(date: string): Date | undefined {
  if (typeof date !== 'string' || !date.trim().length) {
    return undefined
  }

  const acceptedFormats = [
    'dd/MM/yyyy',
    'dd.MM.yyyy',
    'dd-MM-yyyy',
    'yyyy/MM/dd',
    'yyyy.MM.dd',
    'yyyy-MM-dd',
    'MM/dd/yyyy',
    'MM.dd.yyyy',
    'MM-dd-yyyy',
  ]

  for (const format of acceptedFormats) {
    const parsed = parse(date, format, new Date())
    if (isValid(parsed)) {
      return parsed
    }
  }

  return undefined
}

export function userFriendlyFormatDateToISO(date: string): string | undefined {
  const parsed = userFriendlyParseDate(date)
  if (parsed) {
    return parsed.toISOString()
  }

  return undefined
}

/**
 * Converts a date to the string format expected by the datetime-local input.
 * Format: YYYY-MM-DDThh:mm
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local
 * https://stackoverflow.com/questions/28760254/assign-javascript-date-to-html5-datetime-local-input
 */
export function toDateTimeLocalString(date: Date) {
  date.setSeconds(0, 0)
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, -1)
}

export function startOfAppointment(appointment: {fromTime: string; date: Date}): Date {
  const splittedTime = appointment.fromTime.split(':')
  return set(appointment.date, {hours: +splittedTime[0], minutes: +splittedTime[1]})
}
